import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCart';
/** Renders an SVG icon. */
const SvgCart = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M24 25a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-16 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
      />
      <path
        fill="currentColor"
        d="M6.133 4a2 2 0 0 1 1.98 1.717L8.437 8h15.457a2 2 0 0 1 1.99 2.2l-.8 8a2 2 0 0 1-1.99 1.8H10v2h13v2H8v-4.928L6.133 6H4a1 1 0 0 1 0-2zm3.734 14h13.228l.8-8H8.725z"
      />
    </svg>
  );
};
SvgCart.displayName = displayName;
export default SvgCart;
